<template>
    <div class="cst-survey-card-question">
        <h2 v-html="question.question"></h2>
        <component :is="answerType" :question="question"></component>
        <div class="cst-public-review-example">
          <label><input type="checkbox" id="checkbox" v-model="content.privacy"><span class="data-privacy-hint" v-html="$t('txtPrivacyHint', { mail: privacyEmail, link: detailLink })"></span></label>
          <div class="cst-error-hint" v-if="content.errors.indexOf('error_privacy') != -1 && !content.privacy">
            {{ $t('txtPrivacyValidationHint')}}
          </div>
          <!-- <h3>{{ $t('txtExample')}}</h3>
          <img src="/static/sample-public-review.png" /> -->
        </div>
        <card-button-bar :question="question" :skippable="skippable"></card-button-bar>
    </div>

</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import CardAnswerOption from './CardAnswerOption'
    import CardAnswerPercent from './CardAnswerPercent'
    import CardAnswerScale from './CardAnswerScale'
    import CardAnswerText from './CardAnswerText'
    import CardButtonBar from './CardButtonBar'

    export default {
      data: function () {
        return {
          special: {
            privacy: null
          }
        }
      },
      props: ['content'],
      computed: {
        skippable: function () {
          return this.question.optional || this.question.answer.answerValue !== '' || this.question.answer.answerText !== '' // TODO: question optional
        },
        answerType: function () {
          return 'card-answer-' + this.question.type
        },
        question: function () {
          return this.$store.state.decks[0].questions[this.content.id]
        },
        privacyEmail: function () {
          return this.$store.state.hotelData.hotel.email
        },
        detailLink: function () {
          let hotelId = this.$store.state.hotelId
          return `http://hotel-barometer.com/hotel-${hotelId}/detail.html`
        }
      },
      methods: {
        nextCard: function () {
          eventHub.$emit('card-next')
        }
      },
      created: function () {
        eventHub.$emit('set-title', this.question.group_title)
      },
      watch: {
        question: function (newQuestion, oldQuestion) {
          eventHub.$emit('set-title', newQuestion.group_title)
        },
        'special.privacy': function (newValue, oldValue) {
          this.content.privacy = newValue
          if (!!newValue && this.content.errors.indexOf('error_privacy') !== -1) {
            this.content.errors.splice(this.content.errors.indexOf('error_privacy'), 1)
          }
        }
      },
      components: {
        CardAnswerOption, CardAnswerScale, CardAnswerPercent, CardButtonBar, CardAnswerText
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-error-hint {
      .cst-field-error 
    }
    .cst-survey-card-question {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .cst-public-review-example {
      img {
        width: 100%;
      }
    }
    .data-privacy-hint {
      font-size: 80%;
    }
</style>




// WEBPACK FOOTER //
// src/components/CardPublicQuestion.vue